import {NgClass} from '@angular/common';
import {Component, Input} from '@angular/core';
import {FullColorPickerComponent} from 'src/app/editor-interface/shared/full-color-picker/full-color-picker.component';
import {STYLES} from 'src/app/editor-interface/shared/models/styles.model';

@Component({
  standalone: true,
  imports: [NgClass, FullColorPickerComponent],
  template: `
    <app-full-color-picker
      class="color-picker"
      [ngClass]="{rounded: isRounded}"
      [value]="shapeJson.style[param]"
      (picked)="changeStyle($event, param)"></app-full-color-picker>
  `,
  styles: [
    `
      .color-picker {
        display: block;
        width: fit-content;
        margin: auto;
      }
    `
  ]
})
export class ColorPickerComponent<T extends {style: any}> {
  @Input() shapeJson: T;
  @Input() changeStyle: (value: unknown, param: STYLES) => void;
  @Input() param: STYLES;
  @Input() isRounded = false;
}
